import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import { Component } from 'react';
import { bool, func } from 'prop-types';

var StaticRenderer = function (_Component) {
  _inheritsLoose(StaticRenderer, _Component);

  function StaticRenderer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = StaticRenderer.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.shouldUpdate;
  };

  _proto.render = function render() {
    return this.props.render();
  };

  return StaticRenderer;
}(Component);

export { StaticRenderer as default };
StaticRenderer.propTypes = process.env.NODE_ENV !== "production" ? {
  render: func.isRequired,
  shouldUpdate: bool.isRequired
} : {};